export default __webpack_public_path__ + "static/media/Channa Keshava.80efc8fe.jpg";